import React from 'react';

/* --- MODERN PREMIUM STYLES --- */
export const theme = {
  primary: '#4f46e5', // Indigo 600
  primaryHover: '#4338ca',
  secondary: '#f8fafc', // Slate 50
  accent: '#0ea5e9', // Sky 500
  warning: '#f59e0b', // Amber 500
  danger: '#ef4444', // Red 500
  success: '#10b981', // Emerald 500
  textMain: '#0f172a', // Slate 900
  textMuted: '#64748b', // Slate 500
  border: '#e2e8f0', // Slate 200
  surface: '#ffffff',
  background: '#f1f5f9' // Slate 100
};

export const styles = {
  appWrapper: { minHeight: '100vh', backgroundColor: theme.background, padding: '0', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", color: theme.textMain },
  container: { maxWidth: '860px', margin: '0 auto', padding: '20px 16px 96px' },
  headerCard: { backgroundColor: theme.surface, borderRadius: '16px', padding: '24px 20px', marginBottom: '16px', border: `1px solid ${theme.border}` },
  title: { fontSize: '1.8rem', fontWeight: '800', margin: '0 0 4px 0', color: theme.textMain, letterSpacing: '-0.02em' },
  subtitle: { fontSize: '0.95rem', color: theme.textMuted, margin: 0, fontWeight: '500' },
  stepperContainer: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px', position: 'relative' },
  stepperLine: { position: 'absolute', top: '20px', left: '10%', right: '10%', height: '3px', backgroundColor: theme.border, zIndex: 1 },
  stepItem: { position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', width: '20%' },
  stepCircle: { width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '1rem', transition: 'all 0.3s', backgroundColor: theme.surface, border: `2px solid ${theme.border}`, color: theme.textMuted },
  stepCircleActive: { borderColor: theme.primary, backgroundColor: theme.primary, color: '#fff', boxShadow: `0 0 0 4px ${theme.primary}22` },
  stepCircleCompleted: { borderColor: theme.success, backgroundColor: theme.success, color: '#fff' },
  stepLabel: { fontSize: '0.75rem', fontWeight: '600', color: theme.textMuted, textAlign: 'center', transition: 'color 0.3s' },
  stepLabelActive: { color: theme.primary, fontWeight: '700' },
  zoneGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '16px', paddingBottom: '20px' },
  zoneCard: { backgroundColor: theme.surface, border: `1px solid ${theme.border}`, borderRadius: '16px', padding: '20px', cursor: 'pointer', transition: 'background-color 0.2s, border-color 0.2s, color 0.2s', display: 'flex', flexDirection: 'column', gap: '8px' },
  zoneCardHover: { borderColor: '#a5b4fc', boxShadow: '0 4px 16px rgba(79,70,229,0.1)' },
  sectionCard: { backgroundColor: theme.surface, borderRadius: '16px', marginBottom: '16px', padding: '24px 20px', border: `1px solid ${theme.border}`, animation: 'fadeIn 0.3s ease-out' },
  sectionTitle: { fontSize: '1.2rem', fontWeight: '800', color: theme.textMain, marginBottom: '20px', paddingBottom: '12px', borderBottom: `1px solid ${theme.border}` },
  gridContainer: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' },
  inputGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '0.875rem', fontWeight: '700', color: theme.textMain, letterSpacing: '0.01em' },
  input: { padding: '14px 16px', borderRadius: '12px', border: `1.5px solid ${theme.border}`, fontSize: '1rem', outline: 'none', transition: 'border-color 0.2s', backgroundColor: '#f8fafc', color: theme.textMain, width: '100%', boxSizing: 'border-box', fontWeight: '500', minHeight: 52 },
  inputFocus: { backgroundColor: '#fff', borderColor: theme.primary },
  textarea: { minHeight: '100px', resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.5' },
  subBox: { backgroundColor: '#f8fafc', borderRadius: '12px', padding: '20px', border: `1px solid ${theme.border}`, marginBottom: '16px' },
  subBoxTitle: { fontSize: '0.95rem', fontWeight: '800', color: theme.textMain, margin: '0 0 14px 0', display: 'flex', alignItems: 'center', gap: '8px' },
  chipRow: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  chip: { padding: '8px 14px', borderRadius: '99px', border: `1.5px solid ${theme.border}`, backgroundColor: theme.surface, color: '#475569', fontSize: '0.82rem', fontWeight: '600', cursor: 'pointer', transition: 'background-color 0.15s, border-color 0.15s, color 0.15s, box-shadow 0.15s', minHeight: '44px', display: 'inline-flex', alignItems: 'center' },
  chipActive: { backgroundColor: theme.primary, color: '#fff', borderColor: theme.primary },
  chipDanger: { backgroundColor: theme.danger, color: '#fff', borderColor: theme.danger },
  chipWarning: { backgroundColor: theme.warning, color: '#fff', borderColor: theme.warning },
  chipPurple: { backgroundColor: '#8b5cf6', color: '#fff', borderColor: '#8b5cf6' },
  chipSuccess: { backgroundColor: theme.success, color: '#fff', borderColor: theme.success },
  dynamicRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr)) auto', gap: '12px', alignItems: 'center', backgroundColor: '#fff', padding: '14px 16px', borderRadius: '12px', marginBottom: '12px', border: `1px solid ${theme.border}` },
  addBtn: { width: '100%', padding: '13px', borderRadius: '12px', border: `2px dashed #cbd5e1`, backgroundColor: '#f8fafc', color: theme.primary, fontSize: '0.9rem', fontWeight: '700', cursor: 'pointer', transition: 'background-color 0.2s, border-color 0.2s, color 0.2s', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' },
  logicHint: { backgroundColor: '#ecfdf5', borderLeft: `4px solid ${theme.success}`, padding: '12px 16px', borderRadius: '0 10px 10px 0', fontSize: '0.9rem', color: '#065f46', marginTop: '10px', gridColumn: '1 / -1', fontWeight: '500' },
  /* Footer bar — fixed at bottom, full-width button inside */
  footerBar: { position: 'fixed', bottom: 0, left: 0, right: 0, background: '#fff', borderTop: `1px solid ${theme.border}`, padding: '12px 16px', zIndex: 1000 },
  footerInner: { maxWidth: '860px', margin: '0 auto' },
  footerBtn: { display: 'block', width: '100%', padding: '16px', borderRadius: '14px', background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)', color: '#fff', border: 'none', fontWeight: '700', fontSize: '1rem', cursor: 'pointer', minHeight: 54, letterSpacing: '-0.01em', transition: 'opacity 0.15s' },
  footerBtnSuccess: { display: 'block', width: '100%', padding: '16px', borderRadius: '14px', background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', color: '#fff', border: 'none', fontWeight: '700', fontSize: '1rem', cursor: 'pointer', minHeight: 54 },
  /* legacy — kept for any remaining usage */
  stickyFooter: { position: 'sticky', bottom: 20, left: 0, right: 0, backgroundColor: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(12px)', padding: '20px 30px', border: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', zIndex: 100, borderRadius: '24px', maxWidth: '860px', margin: '0 auto' },
  navBtn: { padding: '14px 28px', borderRadius: '12px', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer', transition: 'background-color 0.2s, border-color 0.2s, color 0.2s' },
  btnSecondary: { backgroundColor: '#f1f5f9', color: theme.textMain, border: `1px solid ${theme.border}` },
  btnPrimary: { background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)', color: '#fff', border: 'none' },
};

/* --- MAIN APPLICATION CONSTANTS --- */
export const STEPS = ["Region", "Identification", "Subjective", "Objective", "Diagnosis"];
export { default as API_BASE_URL } from '../../api.js';
export const MAX_CHAT_HISTORY = 20;
export const normalizeList = (value) => Array.isArray(value) ? value : (typeof value === 'string' && value.trim() ? [value.trim()] : []);
export const SUBJECTIVE_ORTHO_DRAFT_KEY = 'subjective-ortho-assessment-draft';
export const SAVED_ASSESSMENTS_KEY = 'saved-ortho-assessments';

export const formatAiNotes = (text = '') => text
  .replace(/\r/g, '')
  .replace(/^#{1,6}\s*/gm, '')
  .replace(/\*\*(.*?)\*\*/g, '$1')
  .replace(/\*(.*?)\*/g, '$1')
  .replace(/^\s*[-*]\s+/gm, '- ')
  .replace(/^\s*\d+\.\s+/gm, '- ')
  .replace(/\n{3,}/g, '\n\n')
  .trim();

export const parseApiResponse = async (response) => {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { error: text };
  }
};

export const DEFAULT_FORM_DATA = {
  name: '', regNo: '', date: new Date().toISOString().split('T')[0], age: '', gender: '', type: 'OP', phone: '',
  occupation: '', dominantHand: 'Right', activityLevel: 'Sedentary',
  chiefComplaint: '', hpiText: '', historyMedical: '', historyPersonal: '', historyFamily: '',
  symSide: 'Right', symOnset: 'Gradual', symType: 'Pain', symSeverity: 0,
  symLocation: '', symRadiation: 'None', symNature: 'Aching', symDurationWeeks: '', mechanismOfInjury: '',
  aggravating: '', relieving: '',
  symptomProgression: '', traumaSeverity: '', painIrritability: '', functionalImpact: '',
  painBehavior: [], painDistribution: [], inflammationSymptoms: [], instabilitySymptoms: [], morningFunction: [], previousHistory: [],
  redFlags: [], functionalLimitations: [], observations: [], palpation: [], gait: [], umnSigns: [],
  rom_list: [], mmt_list: [], glide_list: [], neuro_list: [], functional_list: [], special_list: [], investigation_list: [],
  differentialDiagnosis: '', shortTermGoals: '', longTermGoals: '', treatmentPlan: ''
};

export const renderAiNotes = (text = '') => {
  const lines = formatAiNotes(text).split('\n').filter(line => line.trim());
  return lines.map((line, index) => {
    const trimmed = line.trim();
    const isHeading = /^[A-Za-z][A-Za-z /()-]+:\s*$/.test(trimmed);
    if (isHeading) {
      return (
        <div key={`${trimmed}-${index}`} style={{ fontWeight: '700', marginTop: index === 0 ? 0 : '10px', marginBottom: '4px', color: theme.primary }}>
          {trimmed}
        </div>
      );
    }
    return (
      <div key={`${trimmed}-${index}`} style={{ paddingLeft: trimmed.startsWith('- ') ? '16px' : 0, marginBottom: '4px' }}>
        {trimmed}
      </div>
    );
  });
};
